(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.header-logo').forEach(logo => {
    const gifContainer = logo.querySelector('.header-logo__image-container--gif img');
    if (!gifContainer) return;
    const originalSrc = gifContainer.src;

    logo.addEventListener('mouseenter', () => {
      gifContainer.src = '';
      void gifContainer.offsetWidth;
      gifContainer.src = originalSrc;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["button-custom"] && !Shopify.designMode) return;
  try {
    (function() {
  function handleScrollButtonClick(event) {
    const button = event.target.closest('button[data-target-id]');
    if (!button) return;
    
    event.preventDefault();
    
    const targetId = button.getAttribute('data-target-id');
    if (!targetId) return;
    
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.warn('Scroll target element not found:', targetId);
    }
  }
  
  // Use event delegation on document for better compatibility
  document.addEventListener('click', handleScrollButtonClick);
  
  // Shopify theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      // Event delegation handles dynamically loaded sections automatically
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
